'use client';

import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import type { Countdown as CountdownPayloadType } from '../../graphql/generated/schema';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';
import { calculateTimeLeft } from '../../utils/calculateTimeLeft';

export const Countdown: React.FC<CountdownPayloadType> = ({
  date: countdownDate,
  color,
}) => {
  const dateString = countdownDate;
  const date = new Date(dateString);
  const formattedDate = date.toISOString().split('T')[0];

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(dayjs(formattedDate)));

  const formattedNumber = (number: number): string => (number ? number.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
  }) : '00');

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(dayjs(formattedDate)));
    }, 1000);

    return () => clearInterval(interval);
  }, [formattedDate]);

  return (
    <span className={styles.container}>
      <time
        dateTime={countdownDate}
        className={constructClassName([
          color === 'white' && styles.white,
          color === 'primary' && styles.primary,
        ])}
      >
        {timeLeft.weeks > 0 && `${timeLeft.weeks}w `}
        {timeLeft.days > 0 && `${timeLeft.days}d `}
        {formattedNumber(timeLeft.hours)}
        :
        {formattedNumber(timeLeft.minutes)}
        :
        {formattedNumber(timeLeft.seconds)}
      </time>
    </span>
  );
};
